import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import T from 'components/T';

import { CONTENT_OR_DOC_REQUIRED } from '../../../../../../../../lib/validations/messages';

type Props = {
  hasEmptyItem: boolean;
};

const EmptyItemNotification = ({ hasEmptyItem }: Props) => {
  if (!hasEmptyItem) {
    return null;
  }

  return (
    <M.InlineNotification
      kind='info'
      title={<T value={CONTENT_OR_DOC_REQUIRED} />}
      className='error-message'
      data-testid='empty-item-notification'
      hideCloseButton
    />
  );
};

export default EmptyItemNotification;
